export default class ServiceException {
  constructor(args) {
    this.errorList = args?.errorList;
    this.responseCode = args?.responseCode;
    this.responseMessage = args?.responseMessage;
  }
}
